export default "__VITE_ASSET__7199907b__"